import {useEffect, useState} from 'react';

const UseRandomPhoneHook = () => {
    const phoneNumbers = [
        '+82 70-8874-9334',
        '+82 10-2127-9334'
    ];
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState('');

    useEffect(() => {
        const randomPhoneNumber = phoneNumbers[Math.floor(Math.random() * phoneNumbers.length)];
        setSelectedPhoneNumber(randomPhoneNumber);
    }, []);

    return selectedPhoneNumber;
};

export default UseRandomPhoneHook;